module.exports = __webpack_public_path__ + "img/d20190823_3.53886d76.jpg";